<template>
  <div class="fasciaBoard">
    <div class="header-tool">
      <div class="header-tool-info">
        <div style="display: flex; align-items: center">
          <Breadcrumb>
            <BreadcrumbItem>参展</BreadcrumbItem>
            <BreadcrumbItem>楣板信息</BreadcrumbItem>
          </Breadcrumb>
          <p style="margin-left: 20px; font-size: 20px; color: red">
            <!-- 截止时间:2025年5月20日 -->
          </p>
        </div>
        <div class="header-tool-title">{{ exhibition.name }}</div>
      </div>
    </div>

    <Spin size="large" fix v-if="spinShow">加载中...</Spin>

    <div class="fasciaBoard-content">
      <div class="f-tar">
        <Button @click="setInfo" type="primary">复制公司名称</Button>
      </div>
      <Form
        ref="formInline"
        :model="formInline"
        :rules="ruleInline"
        label-position="right"
        :label-width="120"
        @submit.native.prevent
      >
        <div class="fasciaBoard-tip" v-if="fasciaBoardDownInfo && editStatus">
          您于{{ fasciaBoardDownInfo.changeTime | moment("YY/MM/DD HH:mm:ss") }}
          提交的修改，尚未审核
          <!-- <span v-if="fasciaBoardDownInfo.status === 1">审核通过</span>
          <span v-if="fasciaBoardDownInfo.status === -1">审核未通过</span>-->
          <span
            style="color: #1890ff; margin-left: 10px"
            @click="$router.push('/exhibition/index/exinfo/fascia-alter')"
            >查看我的修改</span
          >
        </div>
        <FormItem label="展区：" :required="true">
          <Input
            style="width: 580px"
            type="text"
            v-model="formInline.exArea"
            disabled
          />
        </FormItem>
        <FormItem label="展位号：" :required="true">
          <Input
            style="width: 580px"
            type="text"
            v-model="formInline.exHall"
            disabled
          />
        </FormItem>
        <FormItem label="公司中文名：" prop="comName">
          <Input
            style="width: 580px"
            type="text"
            v-model="formInline.comName"
            :disabled="fasciaBoardDownInfo && editStatus ? true : false"
          />
        </FormItem>
        <FormItem label="公司英文名：" prop="comNameEn">
          <Input
            style="width: 580px"
            type="text"
            v-model="formInline.comNameEn"
            :disabled="fasciaBoardDownInfo && editStatus ? true : false"
          />
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formInline')"
            style="width: 154px; height: 36px"
            :loading="loading"
            v-if="!editStatus"
            >保存</Button
          >
        </FormItem>
      </Form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validator } from "@/other/validator";
import config from "@assets/config.json";

export default {
  name: "exhibition-info-fasciaBoard",
  data() {
    return {
        spinShow: false,

      formInline: {
        exArea: "", // 展区
        exHall: "", // 展位号
        comName: "", // 公司中文名
        comNameEn: "", // 公司英文名
      },
      ruleInline: {
        // exArea: [
        //   { required: true, message: "请输入展区", trigger: "blur" }
        // ],
        // exHall: [
        //   { required: true, message: "请输入展位号", trigger: "blur" }
        // ],
        comName: [
          { required: true, message: "请输入公司中文名", trigger: "blur" },
        ],
        comNameEn: [
          { required: true, message: "请输入公司英文名", trigger: "blur" },
        ],
      },
      loading: false,
      fasciaBoardIsHave: false,
      fasciaBoardInfo: null,
      fasciaBoardDownInfo: null,
      editStatus: false,
    };
  },
  computed: {
    ...mapGetters({
      joinInfo: "loginModule/getJoinInfo",
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition",
    }),
    exhibitionId() {
      return this.exhibition.id;
    },
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 楣板信息";
    this.init();
  },
  methods: {
    ...mapActions({
      getFasciaBoard: "exhibitionModule/getFasciaBoard",
      getFasciaBoardDown: "exhibitionModule/getFasciaBoardDown",
      submitFasciaBoard: "exhibitionModule/submitFasciaBoard",
      submitFasciaBoardDown: "exhibitionModule/submitFasciaBoardDown",
    }),
    async init() {
        this.spinShow = true;
      this.formInline.exArea = "";
      this.formInline.exHall = "";
      if (
        this.joinInfo &&
        this.joinInfo.boothInfo &&
        this.joinInfo.boothInfo.length
      ) {
        if (
          Object.prototype.toString.call(this.joinInfo.boothInfo) ===
          "[object String]"
        ) {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
        }
        if (
          Object.prototype.toString.call(this.joinInfo.boothInfo) ===
          "[object Object]"
        ) {
          if (this.joinInfo.boothInfo.search(/^\[/) !== -1) {
            this.joinInfo.boothInfo = JSON.parse(this.joinInfo.boothInfo);
          }
          if (this.joinInfo.boothInfo.Hall) {
            this.formInline.exHall =
              this.joinInfo.boothInfo.Hall + "-" + this.joinInfo.boothInfo.Code;
          } else {
            this.formInline.exHall = this.joinInfo.boothInfo.Code;
          }
        }
        if (
          Object.prototype.toString.call(this.joinInfo.boothInfo) ===
          "[object Array]"
        ) {
          let boothInfo = this.joinInfo.boothInfo;
          for (let i = 0; i < boothInfo.length; i++) {
            if (boothInfo.length > 1) {
              if (boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "-" + boothInfo[i].Code + "、";
              }
              if (boothInfo[i].Hall && !boothInfo[i].Code) {
                this.formInline.exHall += boothInfo[i].Hall + "、";
              }
              if (!boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall += boothInfo[i].Code + "、";
              }
            } else {
              if (boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall +=
                  boothInfo[i].Hall + "-" + boothInfo[i].Code;
              }
              if (boothInfo[i].Hall && !boothInfo[i].Code) {
                this.formInline.exHall += boothInfo[i].Hall;
              }
              if (!boothInfo[i].Hall && boothInfo[i].Code) {
                this.formInline.exHall += boothInfo[i].Code;
              }
            }
          }
        }
      }
      if (this.joinInfo && this.joinInfo.exArea) {
        this.formInline.exArea = this.joinInfo.exArea;
      }
      let res = await this.getFasciaBoard(this.joinInfo.joinId);
      if (res) {
        this.fasciaBoardIsHave = true;
        this.fasciaBoardInfo = res;
        this.formInline.comName = res.compName;
        this.formInline.comNameEn = res.compNameEn;
      }
      console.log("楣板信息：", this.fasciaBoardInfo);

      // 获取楣板修改记录
      let result = await this.getFasciaBoardDown(this.joinInfo.joinId);
      if (result) {
        this.fasciaBoardDownInfo = result;
        if (
          this.fasciaBoardDownInfo.syncStatus === 2 &&
          this.fasciaBoardDownInfo.status === 1
        ) {
          this.editStatus = false;
        } else {
          this.editStatus = true;
        }
        console.log("fasciaBoardDownInfo：", this.fasciaBoardDownInfo);
      }
      this.spinShow = false;
    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
      if (!valid) return;

      let req = {
        JoinId: this.joinInfo.joinId,
        CompName: this.formInline.comName,
        CompNameEn: this.formInline.comNameEn,
      };
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      if (!this.fasciaBoardIsHave) {
        let opt1 = {
          ExhibitonId: this.exhibitionId,
          JoinId: this.joinInfo.joinId,
          CommandId: 1, // "CommandId说明":"1：新增，2：修改，3：删除",
          SetValues: req,
        };
        let result = await this.submitFasciaBoard(opt1);
        if (result && result.successed) {
          this.formInline.comName = "";
          this.formInline.comNameEn = "";
          this.$Message.success("保存成功，请等待审核");
          this.formInline.exHall = "";
          this.formInline.exArea = "";
          this.init();
        } else {
          this.$Message.warning(`保存失败，请重试`);
        }
      } else {
        let opt2 = {
          Id: this.fasciaBoardInfo.id,
          ExhibitonId: this.exhibitionId,
          JoinId: this.joinInfo.joinId,
          CommandId: 2, // "CommandId说明":"1：新增，2：修改，3：删除",
          SetValues: req,
        };
        let bool = await this.submitFasciaBoardDown(opt2);
        if (bool && bool.successed) {
          this.$Message.success("保存成功，请等待审核");
          this.formInline.exHall = "";
          this.init();
        } else {
          this.$Message.warning(`保存失败，请重试`);
        }
      }
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate((valid) => {
          resolve(valid);
        });
      });
    },
    setInfo() {
      this.formInline.comName = this.fasciaBoardInfo.compName;
      this.formInline.comNameEn = this.fasciaBoardInfo.compNameEn;
    },
  },
};
</script>

<style scoped lang="scss">
.fasciaBoard {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 800px;
    margin: 30px;
    padding: 40px;
    min-height: 500px;
    background: #fff;
    padding-bottom: 190px;
  }
  .fasciaBoard-tip {
    line-height: 34px;
    padding-left: 120px;
    color: #ff0000;
    span {
      &:hover {
        cursor: pointer;
      }
    }
  }
}
</style>
